import { render, staticRenderFns } from "./ngo-admin-project-list.vue?vue&type=template&id=4b1b7787&scoped=true&"
import script from "./ngo-admin-project-list.vue?vue&type=script&lang=js&"
export * from "./ngo-admin-project-list.vue?vue&type=script&lang=js&"
import style0 from "./ngo-admin-project-list.vue?vue&type=style&index=0&id=4b1b7787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b7787",
  null
  
)

export default component.exports